<p-table
  [value]="files"
  [selection]="selectedFiles"
  (selectionChange)="onSelectedFilesChange($event)"
  selectionMode="multiple"
  dataKey="name"
  [scrollable]="true"
  scrollHeight="flex"
  styleClass="right-panel__table"
  [customSort]="true"
  (sortFunction)="customSort($event)"
>
  <ng-template pTemplate="sorticon" let-sortOrder>
    <div class="right-panel__sort-icon-container">
      <svg
        viewBox="0 0 24 24"
        width="14"
        height="14"
        fill="none"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M7 8l5-4 5 4"
          [attr.stroke]="sortOrder === 1 ? 'var(--fm-primary)' : '#6b7280'"
        />
        <path
          d="M7 16l5 4 5-4"
          [attr.stroke]="sortOrder === -1 ? 'var(--fm-primary)' : '#6b7280'"
        />
      </svg>
    </div>
  </ng-template>
  <ng-template #header>
    <tr>
       <th class="right-panel__th-icon">
         <button
            class="right-panel__action-btn right-panel__action-btn--flex"
            [class.right-panel__action-btn--disabled]="!canLinkSelected"
            [disabled]="!canLinkSelected"
            [title]="linkSelectedTitle"
            (click)="$event.stopPropagation(); linkSelected.emit()"
          >
            <app-svg-icon name="link" [size]="16" />
          </button>
      </th>
      <th class="right-panel__th-drag">
        <div class="right-panel__drag-cell">
          <div class="right-panel__drag-spacer"></div>
        </div>
      </th>
     
      <th pSortableColumn="name">
        <div class="right-panel__th-content">
         
          <span>Név</span>
          <p-sortIcon field="name" />
        </div>
      </th>
      <th pSortableColumn="date">
        <div class="right-panel__th-content">
          <span>Dátum</span>
          <p-sortIcon field="date" />
        </div>
      </th>
      <th pSortableColumn="size">
        <div class="right-panel__th-content">
          <span>Méret</span>
          <p-sortIcon field="size" />
        </div>
      </th>
      <th>Kapcs.</th>
      <th class="right-panel__th-actions">
        <div class="right-panel__th-actions-content">
          <span>Műveletek</span>
          <button
            class="right-panel__action-btn right-panel__action-btn--flex"
            [class.right-panel__action-btn--disabled]="!canDeleteSelected"
            [disabled]="!canDeleteSelected"
            title="Kijelöltek törlése"
            (click)="deleteSelected.emit()"
          >
            <app-svg-icon name="trash" [size]="16" />
          </button>
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template #body let-file>
    <tr
      [attr.data-filename]="file.name"
      [draggable]="file.name !== '..' && !file.isScanning"
      (dragstart)="!file.isScanning && fileDragStart.emit({ event: $event, file })"
      [class.right-panel__row--scanning]="file.isScanning"
      [class.right-panel__row--file]="file.name !== '..' && !file.isScanning"
      [class.right-panel__row--highlighted]="file.name === highlightedFileName()"
      [title]="file.isScanning ? 'Vírusellenőrzés alatt' : ''"
      (click)="onRowClick(file)"
    >
      <td>
        @if (file.name !== '..') {
          <div class="right-panel__drag-cell" (click)="$event.stopPropagation()">
            <app-svg-icon name="drag-handle" [size]="20" class="right-panel__drag-handle" />
            <p-tableCheckbox [value]="file" [disabled]="file.isScanning" />
          </div>
        }
      </td>
      <td>
        @if (file.type === 'folder') {
          <app-svg-icon
            name="folder"
            [size]="20"
            color="var(--fm-primary)"
            class="right-panel__icon--folder"
            style="cursor: pointer"
            (click)="navigateToFolder.emit(file)"
          />
        } @else if (file.isScanning) {
          <i class="pi pi-spin pi-spinner right-panel__scanning-icon"></i>
        } @else if (file.thumbnailUrl) {
          <img [src]="file.thumbnailUrl" [alt]="file.name" class="right-panel__thumbnail" />
        } @else {
          <app-svg-icon [name]="getFileIcon(file.extension)" [size]="20" />
        }
      </td>
      <td>
        @if (editingFile === file) {
          <input
            #editInput
            name="editingName"
            class="right-panel__inline-edit"
            [(ngModel)]="editingName"
            (keyup.enter)="confirmEdit(file)"
            (keyup.escape)="cancelEdit()"
            (blur)="confirmEdit(file)"
            (click)="$event.stopPropagation()"
          />
        } @else if (file.type === 'folder') {
          <span
            class="right-panel__file-name right-panel__file-name--folder"
            [title]="file.name"
            style="cursor: pointer"
            (click)="navigateToFolder.emit(file)"
            >{{ file.name }}</span
          >
        } @else {
          <span class="right-panel__file-name" [title]="file.name">{{ getDisplayName(file) }}</span>
        }
      </td>
      <td>{{ file.date }}</td>
      <td>{{ file.size }}</td>
      <td>
        @if (file.name !== '..') {
          @if (file.links > 0 && file.type === 'file') {
            <div class="right-panel__link-cell">
              <span
                class="right-panel__link-count right-panel__link-count--clickable"
                title="Csatolt linkek megtekintése"
                (click)="$event.stopPropagation(); showLinks.emit(file)"
                >{{ file.links }}
                <app-svg-icon name="link" [size]="16" color="var(--fm-primary)" />
              </span>
            </div>
          } @else if (file.links > 0) {
            <span class="right-panel__link-count"
              >{{ file.links }}
              <app-svg-icon name="link" [size]="16" color="var(--fm-primary)" />
            </span>
          } @else {
            <span class="right-panel__link-count right-panel__link-count--empty"
              >{{ file.links }}
              <app-svg-icon name="link" [size]="16" color="var(--fm-primary)" />
            </span>
          }
        }
      </td>
      <td>
        @if (file.name !== '..') {
          <div class="right-panel__actions" (click)="$event.stopPropagation()">
            <button
              class="right-panel__action-btn right-panel__action-btn--flex"
              [class.right-panel__action-btn--disabled]="(file.links ?? 0) > 0"
              [disabled]="(file.links ?? 0) > 0"
              [title]="(file.links ?? 0) > 0 ? 'Linkelt fájl nem törölhető' : 'Törlés'"
              (click)="deleteItem.emit(file)"
            >
              <app-svg-icon name="trash" [size]="16" />
            </button>
            <button
              class="right-panel__action-btn right-panel__action-btn--flex"
              title="További műveletek"
              (click)="$event.stopPropagation(); openRowMenu($event, file)"
            >
              <i class="pi pi-ellipsis-h"></i>
            </button>
          </div>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
<p-menu #rowMenu [popup]="true" [model]="rowMenuItems" appendTo="body" styleClass="row-action-menu" />
